export default __webpack_public_path__ + "static/media/solicitudes-inac.b0b1e9af.svg";